unit unit_Kundendaten;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, WEBLib.Grids, strutils, DB;

type
  TKundendaten = class(TForm)
    xdsKundendaten: TXDataWebDataSet;
    xdsKundendatenKundennummer: TStringField;
    xdsKundendatenGruppeKunden: TBooleanField;
    xdsKundendatenGruppeLieferanten: TBooleanField;
    xdsKundendatenGruppeSonstige: TBooleanField;
    xdsKundendatenGruppeNichtkunden: TBooleanField;
    xdsKundendatenKontaktgruppe: TStringField;
    xdsKundendatenNachname: TStringField;
    xdsKundendatenVorname: TStringField;
    xdsKundendatenAdresszeile2: TStringField;
    xdsKundendatenAdresszeile3: TStringField;
    xdsKundendatenStrasse: TStringField;
    xdsKundendatenPostleitzahl: TStringField;
    xdsKundendatenOrt: TStringField;
    xdsKundendatenLaenderkuerzel: TStringField;
    xdsKundendatenLand: TStringField;
    xdsKundendatenLaenderkennzeichen: TBooleanField;
    xdsKundendatenAdressanrede: TStringField;
    xdsKundendatenBriefanrede1: TStringField;
    xdsKundendatenAdresseBild: TStringField;
    xdsKundendatenLieferanschrift: TStringField;
    xdsKundendatenTelefonNummer: TStringField;
    xdsKundendatenTelefaxNummer: TStringField;
    xdsKundendatenMobilTelefon: TStringField;
    xdsKundendatenEMail: TStringField;
    xdsKundendatenInternet: TStringField;
    xdsKundendatenUmsatzsteuerID: TStringField;
    xdsKundendatenUmsatzsteuerausweis: TBooleanField;
    xdsKundendatenZahlungsbedingung: TIntegerField;
    xdsKundendatenTransportbedingung: TStringField;
    xdsKundendatenKeinNewsletter: TBooleanField;
    xdsKundendatenTelefonAlternativ: TStringField;
    xdsKundendatenTitel: TStringField;
    xdsKundendatenKundenklasseFarbe: TIntegerField;
    xdsKundendatenRechnungEmail: TStringField;
    xdsKundendatenLoginPW: TStringField;
    xdsKundendatenBesteuerungKey: TIntegerField;
    xdsKundendatenAuftraegeJahr: TFloatField;
    xdsKundendatenAuftraegeVorjahr: TFloatField;
    xdsKundendatenLieferadresseID: TIntegerField;
    xdsKundendatenUSTIDgeprueft: TDateTimeField;
    xdsKundendatenKontaktverbund: TStringField;
    xdsKundendatenHinweis: TStringField;
    xdsKundendatenLatitude: TFloatField;
    xdsKundendatenLongitude: TFloatField;
    xdsKundendatenkmLuftlinie: TFloatField;
    xdsKundendatenGoogleID: TStringField;
    xdsKundendatenGoogleUpdatedUTC: TDateTimeField;
    xdsKundendatenBundesland: TStringField;
    xdsKundendatenRegion: TStringField;
    xdsKundendatenMandatsreferenz: TStringField;
    xdsKundendatenMandatsreferenzVom: TDateTimeField;
    xdsKundendatenLastschriftArt: TStringField;
    xdsKundendatenMahnsperre: TBooleanField;
    xdsKundendatenSuchbegriff: TStringField;
    xdsKundendatenLieferanschriftDaten: TStringField;
    xdsKundendatenExportKasse: TBooleanField;
    xdsKundendatenLoeschvormerkungDatum: TDateTimeField;
    xdsKundendatenLoeschvormerkungGrund: TStringField;
    xdsKundendatenPseudonymisiert: TStringField;
    xdsKundendatenLoginAktiv: TIntegerField;
    xdsKundendatenSonstigeDaten: TStringField;
    TC: TTableControl;
    procedure xdsKundendatenAfterOpen(DataSet: TDataSet);
    procedure WebFormShow(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    btnStammdaten:TButton;
    btnUSTID:TButton;
    btnNewsletter:TButton;
    btnLieferanschrift:TButton;
    btnPasswort:TButton;
    buttonzurueck:TButton;
    btnEmailRechnung:TButton;
    procedure btnStammdatenclick(Sender:TObject);
    procedure btnLieferanschriftclick(Sender:TObject);
    procedure btnUSTIDclick(Sender:TObject);
    procedure btnNewsletterclick(Sender:TObject);
    procedure btnEmailRechnungclick(Sender:TObject);
    procedure btnPasswortclick(Sender:TObject);
    procedure buttonzurueckclick(Sender:TObject);
  protected procedure LoadDFMValues; override; end;

var
  Kundendaten: TKundendaten;

implementation
  uses unit1, unit2, unit_AenderungKundendaten, unit_AenderungUSTID, unit_AenderungZugangsdaten,
  unit_AenderungNewsletter, unit_AenderungLieferanschrift, unit_AenderungEmailRechnung;
{$R *.dfm}

procedure TKundendaten.buttonzurueckclick(Sender:TObject);
begin
  close;
end;

procedure TKundendaten.btnEmailRechnungclick(Sender:TObject);
var
  LFrm:TAenderungEmailRechnung;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TAenderungEmailRechnung;
    begin
      LForm:=(AForm as TAenderungEmailRechnung);
      tc.Visible:=false;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      xdsKundendaten.Close;
      xdsKundendaten.Load;
    end;
  begin
    LFrm:=TAenderungEmailRechnung.CreateNew(@AfterCreate);
    with sender as TButton do
    begin

    end;
    LFrm.ShowModal(@AfterShowmodal);

end;

procedure TKundendaten.btnStammdatenclick(Sender:TObject);
var
  LFrm:TAenderungKundendaten;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TAenderungKundendaten;
    begin
      LForm:=(AForm as TAenderungKundendaten);
      TC.Visible:=false;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      xdsKundendaten.Close;
      xdsKundendaten.Load;
    end;
  begin
    LFrm:=TAenderungKundendaten.CreateNew(@AfterCreate);
    with sender as TButton do
    begin

    end;
    LFrm.ShowModal(@AfterShowmodal);
end;

procedure TKundendaten.btnLieferanschriftclick(Sender:TObject);
var
  LFrm:TAenderungLieferanschrift;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TAenderungLieferanschrift;
    begin
      LForm:=(AForm as TAenderungLieferanschrift);
      TC.Visible:=false;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      xdsKundendaten.Close;
      xdsKundendaten.Load;
    end;
  begin
    LFrm:=TAenderungLieferanschrift.CreateNew(@AfterCreate);
    with sender as TButton do
    begin

    end;
    LFrm.ShowModal(@AfterShowmodal);
end;

procedure TKundendaten.btnUSTIDclick(Sender:TObject);
var
  LFrm:TAenderungUSTID;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TAenderungUSTID;
    begin
      LForm:=(AForm as TAenderungUSTID);
      TC.Visible:=false;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      xdsKundendaten.Close;
      xdsKundendaten.Load;
    end;
  begin
    LFrm:=TAenderungUSTID.CreateNew(@AfterCreate);
    with sender as TButton do
    begin

    end;
    LFrm.ShowModal(@AfterShowmodal);

end;

procedure TKundendaten.btnNewsletterclick(Sender:TObject);
var
  LFrm:TAenderungNewsletter;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TAenderungNewsletter;
    begin
      LForm:=(AForm as TAenderungNewsletter);
      TC.Visible:=false;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      xdsKundendaten.Close;
      xdsKundendaten.Load;
    end;
  begin
    LFrm:=TAenderungNewsletter.CreateNew(@AfterCreate);
    with sender as TButton do
    begin

    end;
    LFrm.ShowModal(@AfterShowmodal);

end;



procedure TKundendaten.btnPasswortclick(Sender:TObject);
var
  LFrm:TAenderungZugangsdaten;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TAenderungZugangsdaten;
    begin
      LForm:=(AForm as TAenderungZugangsdaten);
      LForm.Aenderungsart:=2;
      TC.Visible:=false;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //xdsKundendaten.Close;
      //xdsKundendaten.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer);
      //xdsKundendaten.Load;
      close;
      form1.buttonLogoutClick(sender);
    end;
  begin
    LFrm:=TAenderungZugangsdaten.CreateNew(@AfterCreate);
    with sender as TButton do
    begin

    end;
    LFrm.ShowModal(@AfterShowmodal);

end;

procedure TKundendaten.WebFormShow(Sender: TObject);
begin
  xdsKundendaten.Close;
  xdsKundendaten.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer);
  xdsKundendaten.Load;
end;

procedure TKundendaten.xdsKundendatenAfterOpen(DataSet: TDataSet);
var
  myelement:TJSHTMLElement;
  i:integer;
begin
  tc.Visible:=true;
  TC.RowCount:=10;
  tc.ColCount:=1;
  if TC.Cells[0,0]='' then
  begin
    TC.Cells[0,0]:='<h4>Kundendaten';
    inc(i);
    myelement:=TC.cellelements[0,i];
    buttonzurueck:=TButton.Create(self);
    buttonzurueck.ElementClassName:='btn btn-info text-left';
    buttonzurueck.HeightStyle:=ssauto;
    buttonzurueck.WidthStyle:=ssauto;
    buttonzurueck.tag:=0;
    buttonzurueck.Caption:='<< zurück';
    buttonzurueck.OnClick:=@buttonzurueckClick;
    buttonzurueck.ParentElement:=myelement;
  end;
  i:=1;
  inc(i);
  TC.Cells[0,i]:='<i>Kundennummer</i><br>'+xdsKundendatenKundennummer.asstring;
  inc(i);
  TC.Cells[0,i]:='<i>Stammdaten</i><br>';
  TC.Cells[0,i]:=TC.Cells[0,i]+ReplaceStr(xdsKundendatenAdressebild.asstring,#13+#10,'<BR>');
  TC.Cells[0,i]:=TC.Cells[0,i]+'<br>'+xdsKundendatenEMail.asstring;
  TC.Cells[0,i]:=TC.Cells[0,i]+'<br>'+xdsKundendatenTelefonnummer.asstring;
  TC.Cells[0,i]:=TC.Cells[0,i]+'<br>'+xdsKundendatenMobiltelefon.asstring;
  TC.Cells[0,i]:=TC.Cells[0,i]+'<br>'+xdsKundendateninternet.asstring+'<br>';
  myelement:=TC.cellelements[0,i];
  btnStammdaten:=TButton.Create(self);
  btnStammdaten.ElementClassName:='btn btn-sm btn-info text-left';
  btnStammdaten.HeightStyle:=ssauto;
  btnStammdaten.WidthStyle:=ssauto;
  btnStammdaten.Caption:='ändern';
  btnStammdaten.OnClick:=@btnStammdatenClick;
  btnStammdaten.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='<i>Lieferanschrift</i><br>';
  if xdskundendatenlieferanschriftdaten.AsString<>'' then
  begin
    form1.LARLIST.Text:=xdsKundendatenLieferanschriftDaten.AsString;
    form1.LARLISTtoRECORD;
    TC.Cells[0,i]:=TC.Cells[0,i]+ReplaceStr(xdsKundendatenLieferanschrift.asstring,#13+#10,'<BR>')+'<BR>';
  end
  else
  begin
    TC.Cells[0,i]:=TC.Cells[0,i]+'Lieferanschrift=Rechnungsanschrift<BR>';
  end;
  myelement:=TC.cellelements[0,i];
  btnLieferanschrift:=TButton.Create(self);
  btnLieferanschrift.ElementClassName:='btn btn-sm btn-info text-left';
  btnLieferanschrift.HeightStyle:=ssauto;
  btnLieferanschrift.WidthStyle:=ssauto;
  btnLieferanschrift.Caption:='ändern';
  btnLieferanschrift.OnClick:=@btnLieferanschriftClick;
  btnLieferanschrift.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='<i>Umsatzsteueridentifikationsnr. (EU)</i><br>';
  TC.Cells[0,i]:=TC.Cells[0,i]+ xdsKundendatenUmsatzsteuerID.asstring+'<br>';
  myelement:=TC.cellelements[0,i];
  btnUSTID:=TButton.Create(self);
  btnUSTID.ElementClassName:='btn btn-sm btn-info text-left';
  btnUSTID.HeightStyle:=ssauto;
  btnUSTID.WidthStyle:=ssauto;
  btnUSTID.Caption:='ändern';
  btnUSTID.OnClick:=@btnUSTIDClick;
  btnUSTID.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='<i>Email (für Rechnungsempfang)</i><br>';
  if xdsKundendatenRechnungEmail.AsString='' then
  begin
  TC.Cells[0,i]:=TC.Cells[0,i]+'<i>'+ xdsKundendatenEmail.asstring+'<br>';
  end
  else
  begin
  TC.Cells[0,i]:=TC.Cells[0,i]+ xdsKundendatenRechnungEmail.asstring+'<br>';
  end;

  myelement:=TC.cellelements[0,i];
  btnEmailRechnung:=TButton.Create(self);
  btnEmailRechnung.ElementClassName:='btn btn-sm btn-info text-left';
  btnEmailRechnung.HeightStyle:=ssauto;
  btnEmailRechnung.WidthStyle:=ssauto;
  btnEmailRechnung.Caption:='ändern';
  btnEmailRechnung.OnClick:=@btnEmailRechnungClick;
  btnEmailRechnung.ParentElement:=myelement;


  inc(i);
  TC.Cells[0,i]:='<i>Newsletter ABO (Angebote, wichtige Informationen)</i><br>';
  if xdsKundendatenKeinNewsletter.AsBoolean=false then
   TC.Cells[0,i]:=TC.Cells[0,i]+'ist abonniert<br>'
   else
   TC.Cells[0,i]:=TC.Cells[0,i]+'nicht abonniert<br>';
  myelement:=TC.cellelements[0,i];
  btnNewsletter:=TButton.Create(self);
  btnNewsletter.ElementClassName:='btn btn-sm btn-info text-left';
  btnNewsletter.HeightStyle:=ssauto;
  btnNewsletter.WidthStyle:=ssauto;
  btnNewsletter.Caption:='ändern';
  btnNewsletter.OnClick:=@btnNewsletterClick;
  btnNewsletter.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Passwort<br>';
  myelement:=TC.cellelements[0,i];
  btnPasswort:=TButton.Create(self);
  btnPasswort.ElementClassName:='btn btn-sm btn-info text-left';
  btnPasswort.HeightStyle:=ssauto;
  btnPasswort.WidthStyle:=ssauto;
  btnPasswort.Caption:='ändern';
  btnPasswort.OnClick:=@btnPasswortClick;
  btnPasswort.ParentElement:=myelement;

end;

procedure TKundendaten.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  xdsKundendaten := TXDataWebDataSet.Create(Self);
  xdsKundendatenKundennummer := TStringField.Create(Self);
  xdsKundendatenGruppeKunden := TBooleanField.Create(Self);
  xdsKundendatenGruppeLieferanten := TBooleanField.Create(Self);
  xdsKundendatenGruppeSonstige := TBooleanField.Create(Self);
  xdsKundendatenGruppeNichtkunden := TBooleanField.Create(Self);
  xdsKundendatenKontaktgruppe := TStringField.Create(Self);
  xdsKundendatenNachname := TStringField.Create(Self);
  xdsKundendatenVorname := TStringField.Create(Self);
  xdsKundendatenAdresszeile2 := TStringField.Create(Self);
  xdsKundendatenAdresszeile3 := TStringField.Create(Self);
  xdsKundendatenStrasse := TStringField.Create(Self);
  xdsKundendatenPostleitzahl := TStringField.Create(Self);
  xdsKundendatenOrt := TStringField.Create(Self);
  xdsKundendatenLaenderkuerzel := TStringField.Create(Self);
  xdsKundendatenLand := TStringField.Create(Self);
  xdsKundendatenLaenderkennzeichen := TBooleanField.Create(Self);
  xdsKundendatenAdressanrede := TStringField.Create(Self);
  xdsKundendatenBriefanrede1 := TStringField.Create(Self);
  xdsKundendatenAdresseBild := TStringField.Create(Self);
  xdsKundendatenLieferanschrift := TStringField.Create(Self);
  xdsKundendatenTelefonNummer := TStringField.Create(Self);
  xdsKundendatenTelefaxNummer := TStringField.Create(Self);
  xdsKundendatenMobilTelefon := TStringField.Create(Self);
  xdsKundendatenEMail := TStringField.Create(Self);
  xdsKundendatenInternet := TStringField.Create(Self);
  xdsKundendatenUmsatzsteuerID := TStringField.Create(Self);
  xdsKundendatenUmsatzsteuerausweis := TBooleanField.Create(Self);
  xdsKundendatenZahlungsbedingung := TIntegerField.Create(Self);
  xdsKundendatenTransportbedingung := TStringField.Create(Self);
  xdsKundendatenKeinNewsletter := TBooleanField.Create(Self);
  xdsKundendatenTelefonAlternativ := TStringField.Create(Self);
  xdsKundendatenTitel := TStringField.Create(Self);
  xdsKundendatenKundenklasseFarbe := TIntegerField.Create(Self);
  xdsKundendatenRechnungEmail := TStringField.Create(Self);
  xdsKundendatenLoginPW := TStringField.Create(Self);
  xdsKundendatenBesteuerungKey := TIntegerField.Create(Self);
  xdsKundendatenAuftraegeJahr := TFloatField.Create(Self);
  xdsKundendatenAuftraegeVorjahr := TFloatField.Create(Self);
  xdsKundendatenLieferadresseID := TIntegerField.Create(Self);
  xdsKundendatenUSTIDgeprueft := TDateTimeField.Create(Self);
  xdsKundendatenKontaktverbund := TStringField.Create(Self);
  xdsKundendatenHinweis := TStringField.Create(Self);
  xdsKundendatenLatitude := TFloatField.Create(Self);
  xdsKundendatenLongitude := TFloatField.Create(Self);
  xdsKundendatenkmLuftlinie := TFloatField.Create(Self);
  xdsKundendatenGoogleID := TStringField.Create(Self);
  xdsKundendatenGoogleUpdatedUTC := TDateTimeField.Create(Self);
  xdsKundendatenBundesland := TStringField.Create(Self);
  xdsKundendatenRegion := TStringField.Create(Self);
  xdsKundendatenMandatsreferenz := TStringField.Create(Self);
  xdsKundendatenMandatsreferenzVom := TDateTimeField.Create(Self);
  xdsKundendatenLastschriftArt := TStringField.Create(Self);
  xdsKundendatenMahnsperre := TBooleanField.Create(Self);
  xdsKundendatenSuchbegriff := TStringField.Create(Self);
  xdsKundendatenLieferanschriftDaten := TStringField.Create(Self);
  xdsKundendatenExportKasse := TBooleanField.Create(Self);
  xdsKundendatenLoeschvormerkungDatum := TDateTimeField.Create(Self);
  xdsKundendatenLoeschvormerkungGrund := TStringField.Create(Self);
  xdsKundendatenPseudonymisiert := TStringField.Create(Self);
  xdsKundendatenLoginAktiv := TIntegerField.Create(Self);
  xdsKundendatenSonstigeDaten := TStringField.Create(Self);

  TC.BeforeLoadDFMValues;
  xdsKundendaten.BeforeLoadDFMValues;
  xdsKundendatenKundennummer.BeforeLoadDFMValues;
  xdsKundendatenGruppeKunden.BeforeLoadDFMValues;
  xdsKundendatenGruppeLieferanten.BeforeLoadDFMValues;
  xdsKundendatenGruppeSonstige.BeforeLoadDFMValues;
  xdsKundendatenGruppeNichtkunden.BeforeLoadDFMValues;
  xdsKundendatenKontaktgruppe.BeforeLoadDFMValues;
  xdsKundendatenNachname.BeforeLoadDFMValues;
  xdsKundendatenVorname.BeforeLoadDFMValues;
  xdsKundendatenAdresszeile2.BeforeLoadDFMValues;
  xdsKundendatenAdresszeile3.BeforeLoadDFMValues;
  xdsKundendatenStrasse.BeforeLoadDFMValues;
  xdsKundendatenPostleitzahl.BeforeLoadDFMValues;
  xdsKundendatenOrt.BeforeLoadDFMValues;
  xdsKundendatenLaenderkuerzel.BeforeLoadDFMValues;
  xdsKundendatenLand.BeforeLoadDFMValues;
  xdsKundendatenLaenderkennzeichen.BeforeLoadDFMValues;
  xdsKundendatenAdressanrede.BeforeLoadDFMValues;
  xdsKundendatenBriefanrede1.BeforeLoadDFMValues;
  xdsKundendatenAdresseBild.BeforeLoadDFMValues;
  xdsKundendatenLieferanschrift.BeforeLoadDFMValues;
  xdsKundendatenTelefonNummer.BeforeLoadDFMValues;
  xdsKundendatenTelefaxNummer.BeforeLoadDFMValues;
  xdsKundendatenMobilTelefon.BeforeLoadDFMValues;
  xdsKundendatenEMail.BeforeLoadDFMValues;
  xdsKundendatenInternet.BeforeLoadDFMValues;
  xdsKundendatenUmsatzsteuerID.BeforeLoadDFMValues;
  xdsKundendatenUmsatzsteuerausweis.BeforeLoadDFMValues;
  xdsKundendatenZahlungsbedingung.BeforeLoadDFMValues;
  xdsKundendatenTransportbedingung.BeforeLoadDFMValues;
  xdsKundendatenKeinNewsletter.BeforeLoadDFMValues;
  xdsKundendatenTelefonAlternativ.BeforeLoadDFMValues;
  xdsKundendatenTitel.BeforeLoadDFMValues;
  xdsKundendatenKundenklasseFarbe.BeforeLoadDFMValues;
  xdsKundendatenRechnungEmail.BeforeLoadDFMValues;
  xdsKundendatenLoginPW.BeforeLoadDFMValues;
  xdsKundendatenBesteuerungKey.BeforeLoadDFMValues;
  xdsKundendatenAuftraegeJahr.BeforeLoadDFMValues;
  xdsKundendatenAuftraegeVorjahr.BeforeLoadDFMValues;
  xdsKundendatenLieferadresseID.BeforeLoadDFMValues;
  xdsKundendatenUSTIDgeprueft.BeforeLoadDFMValues;
  xdsKundendatenKontaktverbund.BeforeLoadDFMValues;
  xdsKundendatenHinweis.BeforeLoadDFMValues;
  xdsKundendatenLatitude.BeforeLoadDFMValues;
  xdsKundendatenLongitude.BeforeLoadDFMValues;
  xdsKundendatenkmLuftlinie.BeforeLoadDFMValues;
  xdsKundendatenGoogleID.BeforeLoadDFMValues;
  xdsKundendatenGoogleUpdatedUTC.BeforeLoadDFMValues;
  xdsKundendatenBundesland.BeforeLoadDFMValues;
  xdsKundendatenRegion.BeforeLoadDFMValues;
  xdsKundendatenMandatsreferenz.BeforeLoadDFMValues;
  xdsKundendatenMandatsreferenzVom.BeforeLoadDFMValues;
  xdsKundendatenLastschriftArt.BeforeLoadDFMValues;
  xdsKundendatenMahnsperre.BeforeLoadDFMValues;
  xdsKundendatenSuchbegriff.BeforeLoadDFMValues;
  xdsKundendatenLieferanschriftDaten.BeforeLoadDFMValues;
  xdsKundendatenExportKasse.BeforeLoadDFMValues;
  xdsKundendatenLoeschvormerkungDatum.BeforeLoadDFMValues;
  xdsKundendatenLoeschvormerkungGrund.BeforeLoadDFMValues;
  xdsKundendatenPseudonymisiert.BeforeLoadDFMValues;
  xdsKundendatenLoginAktiv.BeforeLoadDFMValues;
  xdsKundendatenSonstigeDaten.BeforeLoadDFMValues;
  try
    Name := 'Kundendaten';
    Width := 209;
    Height := 378;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 0;
    TC.Width := 209;
    TC.Height := 378;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    xdsKundendaten.SetParentComponent(Self);
    xdsKundendaten.Name := 'xdsKundendaten';
    xdsKundendaten.AfterOpen := xdsKundendatenAfterOpen;
    xdsKundendaten.EntitySetName := 'Adressen';
    xdsKundendaten.Connection := DM2.XDataWebConnection1;
    xdsKundendaten.Left := 24;
    xdsKundendaten.Top := 200;
    xdsKundendatenKundennummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenKundennummer.Name := 'xdsKundendatenKundennummer';
    xdsKundendatenKundennummer.FieldName := 'Kundennummer';
    xdsKundendatenKundennummer.Required := True;
    xdsKundendatenKundennummer.Size := 13;
    xdsKundendatenGruppeKunden.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeKunden.Name := 'xdsKundendatenGruppeKunden';
    xdsKundendatenGruppeKunden.FieldName := 'GruppeKunden';
    xdsKundendatenGruppeLieferanten.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeLieferanten.Name := 'xdsKundendatenGruppeLieferanten';
    xdsKundendatenGruppeLieferanten.FieldName := 'GruppeLieferanten';
    xdsKundendatenGruppeSonstige.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeSonstige.Name := 'xdsKundendatenGruppeSonstige';
    xdsKundendatenGruppeSonstige.FieldName := 'GruppeSonstige';
    xdsKundendatenGruppeNichtkunden.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeNichtkunden.Name := 'xdsKundendatenGruppeNichtkunden';
    xdsKundendatenGruppeNichtkunden.FieldName := 'GruppeNichtkunden';
    xdsKundendatenKontaktgruppe.SetParentComponent(xdsKundendaten);
    xdsKundendatenKontaktgruppe.Name := 'xdsKundendatenKontaktgruppe';
    xdsKundendatenKontaktgruppe.FieldName := 'Kontaktgruppe';
    xdsKundendatenKontaktgruppe.Size := 50;
    xdsKundendatenNachname.SetParentComponent(xdsKundendaten);
    xdsKundendatenNachname.Name := 'xdsKundendatenNachname';
    xdsKundendatenNachname.FieldName := 'Nachname';
    xdsKundendatenNachname.Size := 40;
    xdsKundendatenVorname.SetParentComponent(xdsKundendaten);
    xdsKundendatenVorname.Name := 'xdsKundendatenVorname';
    xdsKundendatenVorname.FieldName := 'Vorname';
    xdsKundendatenVorname.Size := 40;
    xdsKundendatenAdresszeile2.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdresszeile2.Name := 'xdsKundendatenAdresszeile2';
    xdsKundendatenAdresszeile2.FieldName := 'Adresszeile2';
    xdsKundendatenAdresszeile2.Size := 40;
    xdsKundendatenAdresszeile3.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdresszeile3.Name := 'xdsKundendatenAdresszeile3';
    xdsKundendatenAdresszeile3.FieldName := 'Adresszeile3';
    xdsKundendatenAdresszeile3.Size := 40;
    xdsKundendatenStrasse.SetParentComponent(xdsKundendaten);
    xdsKundendatenStrasse.Name := 'xdsKundendatenStrasse';
    xdsKundendatenStrasse.FieldName := 'Strasse';
    xdsKundendatenStrasse.Size := 40;
    xdsKundendatenPostleitzahl.SetParentComponent(xdsKundendaten);
    xdsKundendatenPostleitzahl.Name := 'xdsKundendatenPostleitzahl';
    xdsKundendatenPostleitzahl.FieldName := 'Postleitzahl';
    xdsKundendatenPostleitzahl.Size := 6;
    xdsKundendatenOrt.SetParentComponent(xdsKundendaten);
    xdsKundendatenOrt.Name := 'xdsKundendatenOrt';
    xdsKundendatenOrt.FieldName := 'Ort';
    xdsKundendatenOrt.Size := 40;
    xdsKundendatenLaenderkuerzel.SetParentComponent(xdsKundendaten);
    xdsKundendatenLaenderkuerzel.Name := 'xdsKundendatenLaenderkuerzel';
    xdsKundendatenLaenderkuerzel.FieldName := 'Laenderkuerzel';
    xdsKundendatenLaenderkuerzel.Size := 5;
    xdsKundendatenLand.SetParentComponent(xdsKundendaten);
    xdsKundendatenLand.Name := 'xdsKundendatenLand';
    xdsKundendatenLand.FieldName := 'Land';
    xdsKundendatenLand.Size := 40;
    xdsKundendatenLaenderkennzeichen.SetParentComponent(xdsKundendaten);
    xdsKundendatenLaenderkennzeichen.Name := 'xdsKundendatenLaenderkennzeichen';
    xdsKundendatenLaenderkennzeichen.FieldName := 'Laenderkennzeichen';
    xdsKundendatenAdressanrede.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdressanrede.Name := 'xdsKundendatenAdressanrede';
    xdsKundendatenAdressanrede.FieldName := 'Adressanrede';
    xdsKundendatenAdressanrede.Size := 15;
    xdsKundendatenBriefanrede1.SetParentComponent(xdsKundendaten);
    xdsKundendatenBriefanrede1.Name := 'xdsKundendatenBriefanrede1';
    xdsKundendatenBriefanrede1.FieldName := 'Briefanrede1';
    xdsKundendatenBriefanrede1.Size := 255;
    xdsKundendatenAdresseBild.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdresseBild.Name := 'xdsKundendatenAdresseBild';
    xdsKundendatenAdresseBild.FieldName := 'AdresseBild';
    xdsKundendatenAdresseBild.Size := 255;
    xdsKundendatenLieferanschrift.SetParentComponent(xdsKundendaten);
    xdsKundendatenLieferanschrift.Name := 'xdsKundendatenLieferanschrift';
    xdsKundendatenLieferanschrift.FieldName := 'Lieferanschrift';
    xdsKundendatenLieferanschrift.Size := 255;
    xdsKundendatenTelefonNummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenTelefonNummer.Name := 'xdsKundendatenTelefonNummer';
    xdsKundendatenTelefonNummer.FieldName := 'TelefonNummer';
    xdsKundendatenTelefonNummer.Size := 25;
    xdsKundendatenTelefaxNummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenTelefaxNummer.Name := 'xdsKundendatenTelefaxNummer';
    xdsKundendatenTelefaxNummer.FieldName := 'TelefaxNummer';
    xdsKundendatenTelefaxNummer.Size := 25;
    xdsKundendatenMobilTelefon.SetParentComponent(xdsKundendaten);
    xdsKundendatenMobilTelefon.Name := 'xdsKundendatenMobilTelefon';
    xdsKundendatenMobilTelefon.FieldName := 'MobilTelefon';
    xdsKundendatenMobilTelefon.Size := 25;
    xdsKundendatenEMail.SetParentComponent(xdsKundendaten);
    xdsKundendatenEMail.Name := 'xdsKundendatenEMail';
    xdsKundendatenEMail.FieldName := 'EMail';
    xdsKundendatenEMail.Size := 50;
    xdsKundendatenInternet.SetParentComponent(xdsKundendaten);
    xdsKundendatenInternet.Name := 'xdsKundendatenInternet';
    xdsKundendatenInternet.FieldName := 'Internet';
    xdsKundendatenInternet.Size := 50;
    xdsKundendatenUmsatzsteuerID.SetParentComponent(xdsKundendaten);
    xdsKundendatenUmsatzsteuerID.Name := 'xdsKundendatenUmsatzsteuerID';
    xdsKundendatenUmsatzsteuerID.FieldName := 'UmsatzsteuerID';
    xdsKundendatenUmsatzsteuerausweis.SetParentComponent(xdsKundendaten);
    xdsKundendatenUmsatzsteuerausweis.Name := 'xdsKundendatenUmsatzsteuerausweis';
    xdsKundendatenUmsatzsteuerausweis.FieldName := 'Umsatzsteuerausweis';
    xdsKundendatenZahlungsbedingung.SetParentComponent(xdsKundendaten);
    xdsKundendatenZahlungsbedingung.Name := 'xdsKundendatenZahlungsbedingung';
    xdsKundendatenZahlungsbedingung.FieldName := 'Zahlungsbedingung';
    xdsKundendatenTransportbedingung.SetParentComponent(xdsKundendaten);
    xdsKundendatenTransportbedingung.Name := 'xdsKundendatenTransportbedingung';
    xdsKundendatenTransportbedingung.FieldName := 'Transportbedingung';
    xdsKundendatenTransportbedingung.Size := 100;
    xdsKundendatenKeinNewsletter.SetParentComponent(xdsKundendaten);
    xdsKundendatenKeinNewsletter.Name := 'xdsKundendatenKeinNewsletter';
    xdsKundendatenKeinNewsletter.FieldName := 'KeinNewsletter';
    xdsKundendatenTelefonAlternativ.SetParentComponent(xdsKundendaten);
    xdsKundendatenTelefonAlternativ.Name := 'xdsKundendatenTelefonAlternativ';
    xdsKundendatenTelefonAlternativ.FieldName := 'TelefonAlternativ';
    xdsKundendatenTelefonAlternativ.Size := 50;
    xdsKundendatenTitel.SetParentComponent(xdsKundendaten);
    xdsKundendatenTitel.Name := 'xdsKundendatenTitel';
    xdsKundendatenTitel.FieldName := 'Titel';
    xdsKundendatenKundenklasseFarbe.SetParentComponent(xdsKundendaten);
    xdsKundendatenKundenklasseFarbe.Name := 'xdsKundendatenKundenklasseFarbe';
    xdsKundendatenKundenklasseFarbe.FieldName := 'KundenklasseFarbe';
    xdsKundendatenRechnungEmail.SetParentComponent(xdsKundendaten);
    xdsKundendatenRechnungEmail.Name := 'xdsKundendatenRechnungEmail';
    xdsKundendatenRechnungEmail.FieldName := 'RechnungEmail';
    xdsKundendatenRechnungEmail.Size := 50;
    xdsKundendatenLoginPW.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoginPW.Name := 'xdsKundendatenLoginPW';
    xdsKundendatenLoginPW.FieldName := 'LoginPW';
    xdsKundendatenBesteuerungKey.SetParentComponent(xdsKundendaten);
    xdsKundendatenBesteuerungKey.Name := 'xdsKundendatenBesteuerungKey';
    xdsKundendatenBesteuerungKey.FieldName := 'BesteuerungKey';
    xdsKundendatenAuftraegeJahr.SetParentComponent(xdsKundendaten);
    xdsKundendatenAuftraegeJahr.Name := 'xdsKundendatenAuftraegeJahr';
    xdsKundendatenAuftraegeJahr.FieldName := 'AuftraegeJahr';
    xdsKundendatenAuftraegeVorjahr.SetParentComponent(xdsKundendaten);
    xdsKundendatenAuftraegeVorjahr.Name := 'xdsKundendatenAuftraegeVorjahr';
    xdsKundendatenAuftraegeVorjahr.FieldName := 'AuftraegeVorjahr';
    xdsKundendatenLieferadresseID.SetParentComponent(xdsKundendaten);
    xdsKundendatenLieferadresseID.Name := 'xdsKundendatenLieferadresseID';
    xdsKundendatenLieferadresseID.FieldName := 'LieferadresseID';
    xdsKundendatenUSTIDgeprueft.SetParentComponent(xdsKundendaten);
    xdsKundendatenUSTIDgeprueft.Name := 'xdsKundendatenUSTIDgeprueft';
    xdsKundendatenUSTIDgeprueft.FieldName := 'USTIDgeprueft';
    xdsKundendatenKontaktverbund.SetParentComponent(xdsKundendaten);
    xdsKundendatenKontaktverbund.Name := 'xdsKundendatenKontaktverbund';
    xdsKundendatenKontaktverbund.FieldName := 'Kontaktverbund';
    xdsKundendatenKontaktverbund.Size := 25;
    xdsKundendatenHinweis.SetParentComponent(xdsKundendaten);
    xdsKundendatenHinweis.Name := 'xdsKundendatenHinweis';
    xdsKundendatenHinweis.FieldName := 'Hinweis';
    xdsKundendatenHinweis.Size := 255;
    xdsKundendatenLatitude.SetParentComponent(xdsKundendaten);
    xdsKundendatenLatitude.Name := 'xdsKundendatenLatitude';
    xdsKundendatenLatitude.FieldName := 'Latitude';
    xdsKundendatenLongitude.SetParentComponent(xdsKundendaten);
    xdsKundendatenLongitude.Name := 'xdsKundendatenLongitude';
    xdsKundendatenLongitude.FieldName := 'Longitude';
    xdsKundendatenkmLuftlinie.SetParentComponent(xdsKundendaten);
    xdsKundendatenkmLuftlinie.Name := 'xdsKundendatenkmLuftlinie';
    xdsKundendatenkmLuftlinie.FieldName := 'kmLuftlinie';
    xdsKundendatenGoogleID.SetParentComponent(xdsKundendaten);
    xdsKundendatenGoogleID.Name := 'xdsKundendatenGoogleID';
    xdsKundendatenGoogleID.FieldName := 'GoogleID';
    xdsKundendatenGoogleID.Size := 50;
    xdsKundendatenGoogleUpdatedUTC.SetParentComponent(xdsKundendaten);
    xdsKundendatenGoogleUpdatedUTC.Name := 'xdsKundendatenGoogleUpdatedUTC';
    xdsKundendatenGoogleUpdatedUTC.FieldName := 'GoogleUpdatedUTC';
    xdsKundendatenBundesland.SetParentComponent(xdsKundendaten);
    xdsKundendatenBundesland.Name := 'xdsKundendatenBundesland';
    xdsKundendatenBundesland.FieldName := 'Bundesland';
    xdsKundendatenBundesland.Size := 50;
    xdsKundendatenRegion.SetParentComponent(xdsKundendaten);
    xdsKundendatenRegion.Name := 'xdsKundendatenRegion';
    xdsKundendatenRegion.FieldName := 'Region';
    xdsKundendatenRegion.Size := 50;
    xdsKundendatenMandatsreferenz.SetParentComponent(xdsKundendaten);
    xdsKundendatenMandatsreferenz.Name := 'xdsKundendatenMandatsreferenz';
    xdsKundendatenMandatsreferenz.FieldName := 'Mandatsreferenz';
    xdsKundendatenMandatsreferenz.Size := 34;
    xdsKundendatenMandatsreferenzVom.SetParentComponent(xdsKundendaten);
    xdsKundendatenMandatsreferenzVom.Name := 'xdsKundendatenMandatsreferenzVom';
    xdsKundendatenMandatsreferenzVom.FieldName := 'MandatsreferenzVom';
    xdsKundendatenLastschriftArt.SetParentComponent(xdsKundendaten);
    xdsKundendatenLastschriftArt.Name := 'xdsKundendatenLastschriftArt';
    xdsKundendatenLastschriftArt.FieldName := 'LastschriftArt';
    xdsKundendatenLastschriftArt.Size := 2;
    xdsKundendatenMahnsperre.SetParentComponent(xdsKundendaten);
    xdsKundendatenMahnsperre.Name := 'xdsKundendatenMahnsperre';
    xdsKundendatenMahnsperre.FieldName := 'Mahnsperre';
    xdsKundendatenSuchbegriff.SetParentComponent(xdsKundendaten);
    xdsKundendatenSuchbegriff.Name := 'xdsKundendatenSuchbegriff';
    xdsKundendatenSuchbegriff.FieldName := 'Suchbegriff';
    xdsKundendatenSuchbegriff.Size := 25;
    xdsKundendatenLieferanschriftDaten.SetParentComponent(xdsKundendaten);
    xdsKundendatenLieferanschriftDaten.Name := 'xdsKundendatenLieferanschriftDaten';
    xdsKundendatenLieferanschriftDaten.FieldName := 'LieferanschriftDaten';
    xdsKundendatenLieferanschriftDaten.Size := 255;
    xdsKundendatenExportKasse.SetParentComponent(xdsKundendaten);
    xdsKundendatenExportKasse.Name := 'xdsKundendatenExportKasse';
    xdsKundendatenExportKasse.FieldName := 'ExportKasse';
    xdsKundendatenLoeschvormerkungDatum.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoeschvormerkungDatum.Name := 'xdsKundendatenLoeschvormerkungDatum';
    xdsKundendatenLoeschvormerkungDatum.FieldName := 'LoeschvormerkungDatum';
    xdsKundendatenLoeschvormerkungGrund.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoeschvormerkungGrund.Name := 'xdsKundendatenLoeschvormerkungGrund';
    xdsKundendatenLoeschvormerkungGrund.FieldName := 'LoeschvormerkungGrund';
    xdsKundendatenLoeschvormerkungGrund.Size := 250;
    xdsKundendatenPseudonymisiert.SetParentComponent(xdsKundendaten);
    xdsKundendatenPseudonymisiert.Name := 'xdsKundendatenPseudonymisiert';
    xdsKundendatenPseudonymisiert.FieldName := 'Pseudonymisiert';
    xdsKundendatenPseudonymisiert.Size := 255;
    xdsKundendatenLoginAktiv.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoginAktiv.Name := 'xdsKundendatenLoginAktiv';
    xdsKundendatenLoginAktiv.FieldName := 'LoginAktiv';
    xdsKundendatenSonstigeDaten.SetParentComponent(xdsKundendaten);
    xdsKundendatenSonstigeDaten.Name := 'xdsKundendatenSonstigeDaten';
    xdsKundendatenSonstigeDaten.FieldName := 'SonstigeDaten';
    xdsKundendatenSonstigeDaten.Size := 255;
  finally
    TC.AfterLoadDFMValues;
    xdsKundendaten.AfterLoadDFMValues;
    xdsKundendatenKundennummer.AfterLoadDFMValues;
    xdsKundendatenGruppeKunden.AfterLoadDFMValues;
    xdsKundendatenGruppeLieferanten.AfterLoadDFMValues;
    xdsKundendatenGruppeSonstige.AfterLoadDFMValues;
    xdsKundendatenGruppeNichtkunden.AfterLoadDFMValues;
    xdsKundendatenKontaktgruppe.AfterLoadDFMValues;
    xdsKundendatenNachname.AfterLoadDFMValues;
    xdsKundendatenVorname.AfterLoadDFMValues;
    xdsKundendatenAdresszeile2.AfterLoadDFMValues;
    xdsKundendatenAdresszeile3.AfterLoadDFMValues;
    xdsKundendatenStrasse.AfterLoadDFMValues;
    xdsKundendatenPostleitzahl.AfterLoadDFMValues;
    xdsKundendatenOrt.AfterLoadDFMValues;
    xdsKundendatenLaenderkuerzel.AfterLoadDFMValues;
    xdsKundendatenLand.AfterLoadDFMValues;
    xdsKundendatenLaenderkennzeichen.AfterLoadDFMValues;
    xdsKundendatenAdressanrede.AfterLoadDFMValues;
    xdsKundendatenBriefanrede1.AfterLoadDFMValues;
    xdsKundendatenAdresseBild.AfterLoadDFMValues;
    xdsKundendatenLieferanschrift.AfterLoadDFMValues;
    xdsKundendatenTelefonNummer.AfterLoadDFMValues;
    xdsKundendatenTelefaxNummer.AfterLoadDFMValues;
    xdsKundendatenMobilTelefon.AfterLoadDFMValues;
    xdsKundendatenEMail.AfterLoadDFMValues;
    xdsKundendatenInternet.AfterLoadDFMValues;
    xdsKundendatenUmsatzsteuerID.AfterLoadDFMValues;
    xdsKundendatenUmsatzsteuerausweis.AfterLoadDFMValues;
    xdsKundendatenZahlungsbedingung.AfterLoadDFMValues;
    xdsKundendatenTransportbedingung.AfterLoadDFMValues;
    xdsKundendatenKeinNewsletter.AfterLoadDFMValues;
    xdsKundendatenTelefonAlternativ.AfterLoadDFMValues;
    xdsKundendatenTitel.AfterLoadDFMValues;
    xdsKundendatenKundenklasseFarbe.AfterLoadDFMValues;
    xdsKundendatenRechnungEmail.AfterLoadDFMValues;
    xdsKundendatenLoginPW.AfterLoadDFMValues;
    xdsKundendatenBesteuerungKey.AfterLoadDFMValues;
    xdsKundendatenAuftraegeJahr.AfterLoadDFMValues;
    xdsKundendatenAuftraegeVorjahr.AfterLoadDFMValues;
    xdsKundendatenLieferadresseID.AfterLoadDFMValues;
    xdsKundendatenUSTIDgeprueft.AfterLoadDFMValues;
    xdsKundendatenKontaktverbund.AfterLoadDFMValues;
    xdsKundendatenHinweis.AfterLoadDFMValues;
    xdsKundendatenLatitude.AfterLoadDFMValues;
    xdsKundendatenLongitude.AfterLoadDFMValues;
    xdsKundendatenkmLuftlinie.AfterLoadDFMValues;
    xdsKundendatenGoogleID.AfterLoadDFMValues;
    xdsKundendatenGoogleUpdatedUTC.AfterLoadDFMValues;
    xdsKundendatenBundesland.AfterLoadDFMValues;
    xdsKundendatenRegion.AfterLoadDFMValues;
    xdsKundendatenMandatsreferenz.AfterLoadDFMValues;
    xdsKundendatenMandatsreferenzVom.AfterLoadDFMValues;
    xdsKundendatenLastschriftArt.AfterLoadDFMValues;
    xdsKundendatenMahnsperre.AfterLoadDFMValues;
    xdsKundendatenSuchbegriff.AfterLoadDFMValues;
    xdsKundendatenLieferanschriftDaten.AfterLoadDFMValues;
    xdsKundendatenExportKasse.AfterLoadDFMValues;
    xdsKundendatenLoeschvormerkungDatum.AfterLoadDFMValues;
    xdsKundendatenLoeschvormerkungGrund.AfterLoadDFMValues;
    xdsKundendatenPseudonymisiert.AfterLoadDFMValues;
    xdsKundendatenLoginAktiv.AfterLoadDFMValues;
    xdsKundendatenSonstigeDaten.AfterLoadDFMValues;
  end;
end;

end.